<template>
  <div class="g-inherit m-article">
    <div class="mainContent" v-if="$route.query.type != 'replenishment'">
      <div class="chatContent" :class="{ superMan: sessionId == superMan }">
        <!--阅片-->
        <el-card
          class="box-card"
          style="flex: 1; max-height: 950px"
          v-show="!isHistory"
        >
          <!--聊天-->
          <div class="warpper">
            <div slot="header" class="clearfix">
              <div class="headerWarpper">
                <span>
                  <el-page-header
                    @back="goBack"
                    :content="$route.query.patientName"
                  ></el-page-header>
                </span>
                <el-button
                  style="float: right; padding: 3px 0; color: #fc701a"
                  type="text"
                  @click="getHistory(true)"
                  v-if="sessionId != superMan"
                  >云记录
                </el-button>
              </div>
            </div>
            <div class="out-box">
              <div class="chat-warpper__bottom">
                <div class="c_bd">
                  <ChatList
                    type="session"
                    :msglist="msglist"
                    :userInfos="userInfos"
                    :myInfo="myInfo"
                    :isRobot="isRobot"
                    :caseId="sickInfo.caseId"
                    @msgs-loaded="msgsLoaded"
                    @on-list-avatar="onListAvatar"
                    ref="chatList"
                  />
                </div>
                <div class="c_ft">
                  <ChatEditor
                    v-show="sessionId != superMan"
                    ref="chatEdit"
                    :scene="scene"
                    :to="to"
                    :isRobot="isRobot"
                    :orderTreatId="sickInfo.treatId"
                    :orderNum="sickInfo.orderNumber"
                    :sickInfo="sickInfo"
                    :uid="uid"
                    type="session"
                    :invalid="teamInvalid || muteInTeam"
                    :invalidHint="sendInvalidHint"
                    :advancedTeam="teamInfo && teamInfo.type === 'advanced'"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <!--历史记录-->
        <el-card
          class="box-card"
          style="flex: 1; max-height: 950px"
          v-show="isHistory"
        >
          <div slot="header" class="clearfix">
            <div class="headerWarpper">
              <span>
                {{ lastPageName }}
              </span>
              <el-button
                style="float: right; padding: 3px 0; color: #fc701a"
                type="text"
                @click="getHistory(false)"
                v-if="sessionId != superMan"
                >返回聊天
              </el-button>
            </div>
          </div>
          <div>
            <chat-list
              style="max-height: 700px"
              ref="chatlist"
              type="session"
              :canLoadMore="canLoadMore"
              :msglist="msglist"
              :userInfos="userInfos"
              :myInfo="myInfo"
              :isHistory="true"
            ></chat-list>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="isReciveCall"
      width="50%"
      center
    >
      <div class="invite">
        <div class="avatar">
          <img :src="targetInfo.avatar | headerFilter" />
        </div>
        <div class="tip">{{ patientName }}的视频聊天邀请</div>
        <div class="foot">
          <el-button type="danger" @click="rejectInvite()" round
            >拒绝</el-button
          >
          <el-button type="success" @click="acceptInvite()" round
            >接听</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChatEditor from "@/components/chart/ChatEditor2";
import ChatList from "@/components/chart/ChatList";
import drugPanel from "@/components/drugPanel";
import diseaseCode from "@/components/diseaseCode";
import AdverseEvent from "@/components/common/AdverseEvent";
import prescription from "@/components/prescription";
import util from "@/utils";
import config from "@/config/config.js";
//乐荐暂时屏蔽
import * as WebRTC2 from "@/sdk/NIM_Web_WebRTC2_v4.1.0";

import {
  prescriptionAdd,
  drugSearch,
  getSystem,
  ordersClose,
  memberInfoByAccId,
  setEndCons,
  getOrderDetail,
  getDoctorInformation,
} from "@/api";
import { imMsgReacd, updateVideoStatus } from "@/api/doctor";
export default {
  name: "Chart",
  components: {
    ChatEditor,
    ChatList,
    drugPanel,
    diseaseCode,
    AdverseEvent,
    prescription,
  },
  beforeUpdated() {
    // 提交sdk连接请求
    this.$store.dispatch("connect");
    this.$store.dispatch("updateRefreshState");
  },
  updated() {
    // 提交sdk连接请求
    this.$store.dispatch("connect");
    this.$store.dispatch("updateRefreshState");
  },
  created() {
    this.flag = this.$route.query.type;
  },
  // 进入该页面，文档被挂载
  mounted() {
    // this.initPatientsInfo();
    // this.initDurgSearch();
    // this.system_list();  //字典配置-注释是否有用
    // 此时设置当前会话
    this.$store.dispatch("setCurrSession", this.sessionId);
    setTimeout(() => {
      this.getHistoryMsgs();
    }, 2000);
    this.tipsMessage();
    //音视频
    if (!this.$store.state.client) {
      this.$store.dispatch("initWebRtc").then(async (res) => {});
    }
  },
  // 离开该页面，此时重置当前会话
  destroyed() {
    if (window.nim) {
      this.$store.dispatch("resetCurrSession");
      // this.$store.dispatch("destroy");
    }
  },
  data() {
    return {
      count: "",
      show: true,
      aaa: 0,
      tableData: [],
      DiseaseData: [],
      consFlag: false,
      flag: "", //标识 判断是从问诊订单进入还是远程会诊
      uid: util.timest(),
      superMan: "p2p-21232f297a57a5a743894a0e4a801fc3",
      // restaurants: [],
      timeout: null,
      isHistory: false,
      elSelect: false,
      chatType: "",
      lastPageName: "聊天",
      seconds: 0, //短信验证码读秒
      sendCodeBtnDisable: false,
      phoneCaptcha: "",
      mobilePhone: "",
      uploadUrl: util.Host + "pc/publics/upload",
      leftBtnOptions: {
        backText: " ",
        preventGoBack: true,
      },
      caseForm: {
        drugs_id: "",
        quantity: "",
        dosage: "",
        unit: "",
        frequency: "",
        from: "",
        time: "",
        remark: "",
        specs: "",
      },
      prescription_type: "",
      diagnose_result: "",
      prRemark: "",
      disease_code: "",
      options: [], //药品
      value: "",
      sickInfo: {
        caseContent_dictText: {},
      },
      fileList: [],
      editableTabsValue: "0",
      editableTabs: [], //药品标题数组
      tabIndex: -1,
      select: "",
      drugs: [],
      tabTitleIndex: "",
      drugs_system_list: "",
      activeName: "first",
      pageNum: 0,
      drugShow: false,
      selectDrugList: [],
      curDrugItem: "",
      diagnoseResult: false,

      audio: "",
      callTimer: null,
      isReciveCall: false,
      account: "",
      targetInfo: "",
      sureResult: false,

      patientInfo: {
        drugsList: [],
      },
      imgsList: [],
      dateTime: "",
      patientName: "",
      // account: config.target,
      // sureResult:false,
      // prescriptionId:"",
      // fromType:"",//从最近咨询或者订单列表进入
    };
  },
  filters: {
    getName: function(value) {
      if (value) {
        return value.title;
      }
      return "图文问诊";
    },
    headerFilter: function(img) {
      if (img) {
        return img;
      } else {
        return require("../../assets/images/user-avatar.svg");
      }
    },
  },
  computed: {
    sessionId() {
      let sessionId = this.$route.query.sessionId;
      return sessionId;
    },
    sessionName() {
      let sessionId = this.sessionId;
      let user = null;
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, "");
        if (user === this.$store.state.userUID) {
          return "我的手机";
        } else if (this.isRobot) {
          return this.robotInfos[user].nick;
        } else {
          let userInfo = this.userInfos[user] || {};
          return util.getFriendAlias(userInfo);
        }
      }
    },
    scene() {
      return util.parseSession(this.sessionId).scene;
    },
    to() {
      return util.parseSession(this.sessionId).to;
    },
    // 判断是否是机器人
    isRobot() {
      let sessionId = this.sessionId;
      let user = null;
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, "");
        if (this.robotInfos[user]) {
          return true;
        }
      }
      return false;
    },
    myInfo() {
      return this.$store.state.myInfo;
    },
    userInfos() {
      return this.$store.state.userInfos;
    },
    robotInfos() {
      return this.$store.state.robotInfos;
    },
    msglist() {
      let msgs = this.$store.state.currSessionMsgs;
      return msgs;
    },
    teamInfo() {
      if (this.scene === "team") {
        var teamId = this.sessionId.replace("team-", "");
        return this.$store.state.teamlist.find((team) => {
          return team.teamId === teamId;
        });
      }
      return undefined;
    },
    muteInTeam() {
      if (this.scene !== "team") return false;
      var teamMembers = this.$store.state.teamMembers;
      var Members = teamMembers && teamMembers[this.teamInfo.teamId];
      var selfInTeam =
        Members &&
        Members.find((item) => {
          return item.account === this.$store.state.userUID;
        });
      return (selfInTeam && selfInTeam.mute) || false;
    },
    teamInvalid() {
      if (this.scene === "team") {
        return !(this.teamInfo && this.teamInfo.validToCurrentUser);
      }
      return false;
    },
    sendInvalidHint() {
      if (this.scene === "team" && this.teamInvalid) {
        return `您已不在该${
          this.teamInfo && this.teamInfo.type === "normal" ? "讨论组" : "群"
        }，不能发送消息`;
      } else if (this.muteInTeam) {
        return "您已被禁言";
      }
      return "无权限发送消息";
    },
    canLoadMore() {
      return !this.$store.state.noMoreHistoryMsgs;
    },
    systemInfo() {
      return this.$store.state.systemInfo;
    },
    roomListenType() {
      return this.$store.state.roomListenData.eventType;
    },
    roomListenData() {
      return this.$store.state.roomListenData;
    },
    setRoomStatus() {
      return this.$store.state.setRoomStatus;
    },
  },
  methods: {
    // 获取医生详情
    async getDoctorInformation() {
      const { code, data } = await getDoctorInformation();
      if (code === 1) {
        if (data.videoCallStatus == "12502") {
          await updateVideoStatus();
        }
      }
    },
    // 查看未读消息
    async imMsgReacd() {
      var params = new FormData();
      params.append("doctorId", util.getStore("user_id"));
      params.append("memberId", this.$route.query.memberId || "");
      await imMsgReacd(params);
    },
    handleClick(item) {
      this.drugShow = true;
      const a = JSON.parse(JSON.stringify(item));
      this.$nextTick(() => {
        this.$refs.drugPanel.initRight();
        this.$refs.drugPanel.initDetail(a);
      });
    },
    joinRoom(type = "") {
      const query = {
        channelName: this.sickInfo.orderNumber,
        requestId: this.uid,
        uid: this.uid,
        account: this.to,
        target: this.sickInfo.caseContent_dictText.name,
        isInvited: type,
        device: "1,2",
      };
      this.$router.push({
        path: "/netcall",
        query,
      });
    },
    lingStop() {
      const audio = this.audio;
      audio && audio.pause();
      this.audio = "";
      clearInterval(this.callTimer);
    },
    lingPlay() {
      this.audio = new Audio();
      this.audio.src = require("../../assets/begg.mp3");
      this.callTimer = setInterval(() => {
        this.audio &&
          this.audio
            .play()
            .then(() => {
              console.log("播放成功");
            })
            .catch(() => {
              this.$message.error("音频设备未允许，请在设置中心允许播放音频");
              clearInterval(this.callTimer);
            });
      }, 1000);
    },
    rejectInvite() {
      const params = {
        channelId: this.roomListenData.channelId,
        account: this.roomListenData.from,
        requestId: this.roomListenData.requestId,
      };
      this.$store
        .dispatch("rejectInvite", params)
        .then(async (res) => {
          console.log("拒绝成功");
          this.lingStop();
          this.isReciveCall = false;
          this.$store.dispatch("setListenRoomData", "");
          await updateVideoStatus();
        })
        .catch((error) => {
          this.lingStop();
          this.isReciveCall = false;
          this.$store.dispatch("setListenRoomData", "");
          console.log("error", error);
          if (error.code == 10404) {
            this.$message.error("频道不存在");
          } else if (error.code == 10408) {
            this.$message.error("邀请不存在或已过期");
          } else if (error.code == 10409) {
            this.$message.error("邀请已经拒绝");
          } else if (error.code == 10410) {
            this.$message.error("邀请已经接受");
          } else if (error.code == 10201) {
            this.$message.error("对方不在线");
          }
        });
    },
    acceptInvite(type) {
      const params = {
        channelId: this.roomListenData.channelId,
        account: this.roomListenData.from,
        requestId: this.roomListenData.requestId,
      };
      console.log(params);
      this.$store
        .dispatch("acceptInvite", params)
        .then(async () => {
          this.lingStop();
          this.isReciveCall = false;
          this.$router.push({
            path: "/netcall",
            query: {
              channelName: this.roomListenData.channelName,
              requestId: this.uid,
              uid: this.uid,
              account: this.to,
              target: this.patientName,
              device: "1,2",
            },
          });
        })
        .catch((error) => {
          if (error.code == 10404) {
            this.$message.error("频道不存在");
          } else if (error.code == 10408) {
            this.$message.error("邀请不存在或已过期");
          } else if (error.code == 10409) {
            this.$message.error("邀请已经拒绝");
          } else if (error.code == 10410) {
            this.$message.error("邀请已经接受");
          } else if (error.code == 10201) {
            this.$message.error("对方不在线");
          }
        });
    },
    estarPhone(phoneNum) {
      if (phoneNum) {
        let str = String(phoneNum),
          strLen = str.slice(-7, -3);
        return str.replace(strLen, "****");
      } else {
        return "手机号未设置";
      }
    },
    //获取手机验证码登录
    async getPhoneCaptcha() {
      this.mobilePhone = this.sickInfo.doctorMobile;
      if (this.mobilePhone === "") {
        this.elementTips("error", "手机号码不能为空");
        return;
      }
      let isPhone = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/.test(
        this.mobilePhone
      );
      if (!isPhone) {
        this.elementTips("error", "手机格式不正确");
        return;
      }
      const params = {
        mobile: this.mobilePhone,
        smsMode: "6",
      };
      let res = await getCaptcha(params);
      console.log("获取验证码", res);
      const { code, message } = res;

      if (code === 200) {
        this.countDown();
        this.elementTips("success", message);
        this.sendCodeBtnDisable = true;
      } else {
        this.sendCodeBtnDisable = false; //错误的情况下 解除禁止
        this.elementTips("warning", message);
      }
    },
    countDown() {
      this.seconds = 60;
      this.secondsTimeId = setInterval(() => {
        if (this.seconds > 0 && this.seconds <= 60) {
          this.seconds--;
        } else {
          clearInterval(this.secondsTimeId);
          this.seconds = 0;
          this.sendCodeBtnDisable = false;
        }
      }, 1000);
    },
    /*
     * 提示信息
     * */
    elementTips: function(type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    /**
     * 诊断结果
     */
    on_disease_code(data, type) {
      this.diagnoseResult = type;
      // this.diagnose_result = data.title;
      // this.disease_code = data.code;

      this.patientInfo.treatmentResName = data.title;
      this.patientInfo.treatmentRes = data.id;
    },
    //结束会诊
    onEndCons() {
      let consId = this.$route.query.treatId;
      setEndCons({ consId }).then((res) => {
        if (res.success) return (this.consFlag = true);
      });
    },
    //结束诊断
    async endChat() {
      try {
        const params = {
          orderTreatId: this.$route.query.treatId,
        };
        let res = await ordersClose(params);
        if (res.success) {
          this.$message({
            type: "success",
            message: "本次诊断结束",
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
        this.initPatientsInfo();
      } catch (error) {
        console.log(error);
      }
    },

    changeType(keyword) {
      if (keyword == 1 || keyword == 2) {
        this.pageNum = 0; //切换药品类型时，重置为0，下面+1 = 1 访问成1
      }
      this.pageNum = this.pageNum + 1;
      this.options = [];
      let data = {
        type: this.prescription_type,
        keyword: this.value,
        cate_id: "1",
        pageNum: this.pageNum,
        pageSize: "10",
      };
      drugSearch(data).then((res) => {
        this.options = this.options.concat(res.data.data);
      });
    },
    tipsMessage() {
      if (this.sessionId == this.superMan) {
        return;
      }
      //读取sessionStorage 提示只提示一次
      const tipsMessage = JSON.parse(sessionStorage.getItem("tipsMessage"));
      if (tipsMessage == 1) {
        return;
      }
      //将信息存入本地缓存sessionStorage
      sessionStorage.setItem("tipsMessage", JSON.stringify(1));
      this.$notify({
        title: "温馨提示",
        dangerouslyUseHTMLString: true,
        message: `<div>1、医生须完整查看患者病历后开始诊疗行为。</div>
          <div>2、根据相关规定，互联网医院不得为低龄儿童（6岁以下）开具互联网儿童用药处方。</div>
          <div>3、根据相关规定，互联网医院不得开具麻醉药品、精神药品等特殊管理药品的处方。</div>
          <div>4、本互联网医院平台仅提供复诊服务、不做初诊。</div>`,
        type: "warning",
        duration: 0,
      });
    },
    /*
        切换药品事件
        通过两个数组对应索引的位置赋值
      */
    tabClick(item) {
      this.tabTitleIndex = item.index;
      for (let i = 0; i < this.drugs.length; i++) {
        if (item.index == i) {
          this.caseForm = this.drugs[i];
        }
      }
    },

    isTipPreOrder() {
      const that = this;
      this.$confirm(
        "您的处方已被拒绝，需要您再次查看病历信息，处方信息以后继续操作?",
        "提示",
        {
          confirmButtonText: "前去查看",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          sessionStorage.setItem(
            "tipPreOrder" + that.sickInfo.orders_id,
            JSON.stringify(1)
          );
          that.detailHandle(that.sickInfo);
        })
        .catch(() => {
          // 取消  啥也不干 不能再提交处方
        });
    },

    /**
     * 删除药品
     */
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      let drugs = this.drugs;
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      this.drugs = drugs.filter((tab) => tab.name !== targetName);
      console.log("this.drugs", this.drugs);
    },

    detailHandle(sickInfo) {
      let query = {
        casesId: this.sickInfo.caseContent_dictText.id,
        sessionId: this.sessionId,
        prescriptionId: sickInfo.prescriptionId,
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query,
      });
    },
    /*
        处方列表跳转
      */
    prescription() {
      this.$router.push({
        path: "/index/user/prescription",
      });
    },
    //切换历史记录
    getHistory(type) {
      //true 云记录 false 返回
      this.isHistory = type;
      type == true
        ? (this.lastPageName = "历史记录")
        : (this.lastPageName = "聊天");
    },
    //获取下拉选项
    system_list() {
      let data = {
        type: "all",
      };
      getSystem(data).then((res) => {
        this.drugs_system_list = res.data;
      });
    },

    //这里获取诊断的搜索
    // initDurgSearch() {
    //   diagnose_result_search({}).then((res) => {
    //     this.restaurants = res.data;
    //   });
    // },
    // querySearch(queryString, cb) {
    //   var restaurants = this.restaurants;
    //   var results = queryString
    //     ? restaurants.filter(this.createFilter(queryString))
    //     : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.content
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    //上传成功
    handleDataSuccess(res, file) {
      const that = this;
      this.caseForm.images.push(res.data.url);
    },
    //上传之前
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("图片格式错误");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //药方添加
    setPrescription() {
      // 1.判断数组字段内容是否为空
      // 2.判断数组字段长度是否为12
      for (var i = 0; i < this.drugs.length; i++) {
        var new_drugs = this.drugs[i];
        const title = "";
        for (let k in new_drugs) {
          if (k == "drugs_name") {
            title = new_drugs[k];
          }
          if (
            new_drugs[k] == "" ||
            new_drugs[k] == undefined ||
            new_drugs[k] == null
          ) {
            this.$message.error(title + "药品有内容未填写");
            return;
          }
        }
        if (Object.keys(new_drugs).length < 10) {
          this.$message.error(title + "药品有内容未填写");
          return;
        }
      }
      this.$refs.caseForm.validate((valid) => {
        if (valid) {
          const params = {
            type: this.prescription_type,
            orders_id: this.sickInfo.orders_id,
            drugs: this.drugs,
            diagnose_result: this.diagnose_result,
          };
          prescriptionAdd(params).then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.initPatientsInfo();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "请完成内容",
          });
          return false;
        }
      });
    },
    open() {
      this.$confirm(
        "不得为6岁以下儿童开具药品，不得开具毒、麻类药品!",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "",
          showCancelButton: false,
          // type: 'warning'
        }
      )
        .then(() => {
          this.addDrugForm();
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消提交'
          // });
        });
    },
    //初始化患者信息
    async initPatientsInfo() {
      try {
        if (this.$route.query.treatId) {
          this.getOrderInfoById(this.$route.query.treatId);
          this.fromType = "orderTreat";
        } else {
          var sick_im_accid = this.getCaption(this.$route.query.sessionId);
          if (sick_im_accid) {
            this.getMemberInfoByAccId(sick_im_accid);
            this.fromType = "ask";
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getOrderInfoById(treatId) {
      try {
        let data = {
          orderNo: treatId,
        };
        let res = await getOrderDetail(data);
        if (res.code == 1) {
          this.sickInfo = res.data;
          this.prescriptionId = res.data.prescriptionId;
          this.caseForm.orders_id = this.sickInfo.orders_id;
          this.initpPrescriptionDetail();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMemberInfoByAccId(sick_im_accid) {
      try {
        let data = {
          memberAccId: sick_im_accid,
        };
        let res = await memberInfoByAccId(data);
        if (res.success) {
          this.sickInfo = res.result;
          this.prescriptionId = res.result.prescriptionId;
          this.caseForm.orders_id = this.sickInfo.orders_id;
          this.initpPrescriptionDetail();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async initpPrescriptionDetail() {
      // this.prescriptionSelect();
      try {
        if (
          this.prescriptionId !== "" &&
          (this.sickInfo.status == 7 || this.sickInfo.status == 4)
        ) {
          let data = {
            id: this.prescriptionId,
          };
          let res = await prescriptionDetail(data);
          if (res.success) {
            console.log(res);
            this.diagnose_result = res.result.diagnoseResult;
            this.selectDrugList = res.result.arrayDrug;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getHistoryMsgs() {
      this.$store.dispatch("getHistoryMsgs", {
        scene: this.scene,
        to: this.to,
      });
    },
    goBack() {
      let fromType = this.$route.query.fromType;
      if (fromType == "workdetail") {
        this.$router.push({
          path: "/index/user/patients",
        });
      } else {
        // this.$router.push({
        //   path: "/index/work/consultation",
        // });
        this.$router.push({
          path: "/index/work/patients",
        });
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    /**
     * 删除图片方法
     */
    handleRemove(file, fileList) {
      const url = file.response.data.url;
      for (var i = 0; i < this.caseForm.images.length; i++) {
        if (this.caseForm.images[i] == url) {
          this.caseForm.images.splice(i, 1);
        }
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    onClickBack() {
      window.stopPlayAudio && window.stopPlayAudio();
      window.history.go(-1);
    },
    msgsLoaded() {},
    //头像点击
    onListAvatar(item) {
      let sickInfo = this.sickInfo;
      if (sickInfo.is_hava_report == 1) {
        this.$router.push({
          path: "/index/user/reportManage",
        });
        return;
      }
      if (
        sickInfo.im_accid &&
        sickInfo.sick_id &&
        sickInfo.id &&
        sickInfo.orders_id
      ) {
        let query = {
          sickImId: sickInfo.im_accid,
          sickId: sickInfo.sick_id,
          // casesId: sickInfo.id,
          casesId: this.sickInfo.caseContent_dictText.id,
          orderId: sickInfo.orders_id,
          from: "chat",
        };
        this.$router.push({
          path: "/index/work/slice",
          query,
        });
      } else {
        this.$message({
          type: "warning",
          message: "患者信息不完善，请提醒患者完善信息",
        });
      }
    },
  },
  watch: {
    systemInfo(curVal, oldVal) {
      console.log(curVal, "监听消息");

      let content = JSON.parse(curVal.content);
      if (content.custom_type === "tellReport") {
        console.log(curVal, "监听APP签字成功");
        this.initPatientsInfo();
        this.$message({
          showClose: true,
          message: content.msg,
          type: "success",
        });
      }
    },
    roomListenType(val, oldVal) {
      console.log(val, "视频");
      if (!val) return;
      if (val === "INVITE") {
        this.isReciveCall = true;
        this.$store
          .dispatch("getUserInfo", this.roomListenData.from)
          .then((res) => {
            console.log("res:", res);
            this.patientName = res.nick;
            this.$nextTick(() => {
              this.targetInfo = res;
              this.isReciveCall = true;
              this.lingPlay();
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (val === "CANCEL_INVITE") {
        this.lingStop();
        this.isReciveCall = false;
      } else if (
        val === "REJECT" ||
        val === "ROOM_JOIN" ||
        val === "ROOM_CLOSE"
      ) {
        this.isReciveCall = false;
        this.lingStop();
      } else if (val === "ACCEPT") {
        this.lingStop();
        this.isReciveCall = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.g-inherit {
  padding: 10px;
  width: 60%;
  //   text-align: center;
  margin: auto;
}
.headerWarpper {
  margin: 15px 20px 0 5px;
}

.pageWarpper {
  width: 100%;

  text-align: center;
}
.patientsContent .el-alert {
  margin-bottom: 20px;
}

.superMan {
  flex: 0 0 96% !important;
}
.more {
  padding: 5px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  text-align: center;
}
.drugList {
  margin: 20px 0;
  .drug_title {
    font-size: 16px;
    color: #409eff;
    margin: 10px 0;
  }
  .drug-item {
    .drug-edit {
      text-align: right;
      button {
        padding: 6px 19px !important;
      }
    }
  }
}

.topBox .el-button--text {
  color: #fc701a;
}

.topBox {
  .el-textarea__inner:focus {
    border-color: #fc701a !important;
  }
}
// .m-chat-editor {
//   .el-button {
//     background-color: #fc701a !important;
//     border-color: #fc701a !important;
//   }
// }

.el-tabs__nav-wrap::after {
  background-color: #fff !important;
}

.el-card__body .el-tabs__item.is-active {
  color: #fc701a;
  border-color: #fc701a !important;
}

.el-card__body .el-tabs__item:hover,
.el-card__body .el-button--text {
  color: #fc701a;
}

.el-card__body .el-tabs__active-bar {
  background-color: #fc701a;
}
.chat_warpper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .out-box {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .chat-warpper__bottom {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .c_bd {
      flex: 1;
      overflow: hidden;
      height: 100%;
    }
  }
}

.invite {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .avatar {
    width: 100px;
    height: 100px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin: 20px 0;
  }
  .foot {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .el-button {
      width: 120px;
    }
  }
}
// .el-form-item{
//   margin-top: 55px;
// }
// .el-form-item__label{
//   float: none;
// }
// .el-form-item__content{
//   margin: 0 !important;
// }
.el_input {
  width: 50%;
  float: left;
  margin-right: 30px;
}
.el_image {
  width: 40%;
  // float: right;
  position: absolute;
  right: 0;
  top: 0;
}
.el_image img {
  vertical-align: middle;
}
.p_click {
  z-index: 999999;
  /* display: inline-table; */
  background: #b7b7b7;
  position: absolute;
  right: 0;
  color: #fff;
  padding: 0 5px;
  border-radius: 10px;
}
.captcha_phone p {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}
.captcha-item {
  position: relative;
  // right: -53px;
  // bottom: 0;
  width: 100%;
  margin-bottom: 10px;
}
.get-captcha {
  position: absolute;
  top: 7px;
  right: 2px;
  background-color: transparent;
  color: #fc701a;
  border: none; // 去掉边框
  outline: none; // 去掉点击按钮后的边框
  cursor: pointer;
}
.login-pass {
  border-style: none none none;
  border-bottom: 1px solid #dcdcdc;
  width: calc(100% - 30px);
  background-image: url("../../assets/images/login-pass.png");
  background-size: 15px 15px;
  background-position: 3px 4px;
  background-repeat: no-repeat;
  padding: 5px 10px 6px 20px;
}
.login-user:focus,
.login-pass:focus {
  outline: none;
}

.c_ft {
  position: relative;
}
</style>
